<template>
  <section class="page-header" :class="isHome?'home':''">
    <div class="header-left">
       <img class="logo" src="@/assets/images/global-logo(2).png" />
       <span class="header-title" @click="goHome">{{ sysTitle }}</span>
       <tab-bar></tab-bar>
    </div>
<!--    <div class="header-platform pleatform" :class="{ 'is-active': menuActive === 'platform' }" @click="handleTabClick">-->
<!--      <img src="@/assets/images/pre-set.jpg">-->
<!--      <span>权限及设置</span>-->
<!--    </div>-->
    <div class="header-right">
      <!-- <el-dropdown class="park-picker" trigger="click" @command="handleAreaChange">
        <span class="el-dropdown-link">
          {{parkName}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item v-for="park in parkList" :key="park.id" :command="park">{{park.name}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <div class="user-info">
        <el-dropdown @command="handleCommand" trigger="click">
          <span>
            <!-- <el-avatar class="avatar" size="small" :src="userInfo.headImgUrl"></el-avatar> -->
            <img class="avatar" v-if="userInfo.headPortaitUrl" :src="userInfo.headPortaitUrl" />
            <img class="avatar" v-else src="@/assets/images/userDefault.png" />
            <span class="name">{{ userInfo.realName || userInfo.nickName}}</span>
            <span class="el-dropdown-link operation">
              <i style="color: #999;" class="el-icon-arrow-down"></i>
            </span>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="goConfig">设置</el-dropdown-item> -->
            <el-dropdown-item command="updateUserInfo">修改信息</el-dropdown-item>
            <el-dropdown-item command="updatePwd">修改密码</el-dropdown-item>
            <el-dropdown-item command="userLogout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <update-pwd v-if="updatePwdVisible" @close="updatePwdVisible = false" :force="updateForce" :userInfo="userInfo"></update-pwd>
    <editUserInfo v-if="updateUserInfoVisible" @close="updateUserInfoVisible = false" :userInfo="userInfo"></editUserInfo>
  </section>
</template>

<script>
import UpdatePwd from '@/components/common/UpdatePwd'
import editUserInfo from '@/components/common/editUserInfo'
import TabBar from '@/views/layout/TabBar'
import { mapGetters } from 'vuex'
export default {
  name: 'page-header',
  inject: ['reload'],
  components: {
    UpdatePwd,
    editUserInfo,
    TabBar
  },
  data () {
    return {
      menuActive: '',
      updatePwdVisible: false,
      updateUserInfoVisible: false,
      sysTitle: '通明湖信息城数字服务平台'
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'parkList',
      'parkName',
      'parkId'
    ]),
    isHome () {
      return this.$route.name === 'home'
    }
  },
  created () {
    if (!this.userInfo.change) {
      this.updatePwdVisible = true
      this.updateForce = true
    }
  },
  methods: {
    handleTabClick () {
      // 处理平台tab点击的逻辑
    },
    handleCommand (methodName) {
      this[methodName]()
    },
    updatePwd () {
      this.updatePwdVisible = true
    },
    userLogout () {
      this.utils.logout()
    },
    goHome () {
      this.$store.dispatch('setMenuActive', 'home')
    },
    handleAreaChange (area) {
      this.$store.dispatch('setParkId', area.id)
      this.reload()
    },
    updateUserInfo () {
      this.updateUserInfoVisible = true
    }
  }
}
</script>
<style lang="less">
@media screen and (max-width: 1600px) {
  .page-header .header-left {
    min-width: 200px;
    height: 60px
  }

  .page-header .header-left /deep/ .tabbar {
    margin-left: 30px
  }

  .page-header .header-left /deep/ .tabbar .tabbar-p {
    left: 154px
  }
}

@media screen and (max-width: 1430px) {
  .page-header .header-left {
    min-width: 220px;
    margin-right: 20px;
    height: 60px
  }

  .page-header .header-left /deep/ .tabbar {
    margin-left: 20px
  }

  .page-header .header-left /deep/ .tabbar .tabbar-p {
    left: 172px
  }
}
.page-header {
  width: 100%;
  margin: 0 auto;
  height: 60px;
  line-height: 60px;
  min-width: 700px;
  color: #fff;
  background-image: linear-gradient(to left,#25425e, #132332);
  display: flex;
  align-items: center;
  box-shadow: 0 2px 1px 0 rgba(0, 0, 0, 0.04);
  justify-content: space-between;
  transition: padding .5s ease;
  // padding: 0 20px;
  padding-left: 20px;
  &.home{
    padding: 0 110px 0 120px;
    // padding: 0 120px;
  }
  .header-platform {
    background: hsla(0, 0%, 100%, .09);
    border-radius: 15px;
    width: 108px;
    height: 30px;
    line-height: 30px;
    margin: 0 32px 0 10px;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      vertical-align: middle;
      margin-left: 13px;
    }
    span {
      color: #c2cad1;
      font-size: 12px;
    }
  }
  .header-left {
    cursor: pointer;
    // padding-left: 24px;
    text-align: left;
    min-width: 200px;
    display: flex;
    flex: 1;
    align-items: center;
    .logo {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      height: 44px;
      width: 44px;
    }
    .header-title {
      font-size: 18px;
      color: #fff;
      font-weight: bold
    }
  }
  .header-right {
    display: flex;
    float: right;
    text-align: right;
    justify-content: space-between;
    margin-right: 20px;
    .user-info {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .avatar {
        vertical-align: middle;
        cursor: pointer;
        margin-right: 10px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
      }
      .name {
        margin-right: 10px;
        color: #fff;
      }
    }
    .park-picker {
      margin-right: 40px;
      color: #009dc2;

    }
  }
}
@media screen and (max-width: 1600px) {
  .page-header{
    .header-left{
      min-width:60px;
      margin-right: 20px;
    }
    .header-title{
      // display: none;
    }
    &.home{
      // padding: 0 80px;
      padding: 0 10px 0 20px;
    }
  }
}
@media screen and (max-width: 1400px) {
  .page-header{
    .header-left{
      min-width:60px;
      margin-right: 20px;
    }
    .header-title {
      // display: none;
    }
    &.home{
      // padding: 20px;
      padding: 0 10px 0 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/views/layout/PageHeader.vue